//import 'default-passive-events'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueResize from 'vue-resize'
import 'vue-resize/dist/vue-resize.css'
import App from './App'
import router from './router'
import store from './vuex' // 引入设置好基础的mock, 用于拦截请求
import _ from 'lodash'
import './directive/dialogDrag'
import dataV from '@jiaminghi/data-view'
import moment from 'moment'
import less from 'less'
import VueInteractJs from 'vue-interactjs'
import recur from 'moment-recur'
//引入格式化组件
import format from 'vue-text-format'
// import('./mock/index')

//引入
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

// Import 富文本编辑器Froala
import VueFroala from 'vue-froala-wysiwyg'


// 引入 Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min')
// 引入 Froala 中文语言包
require('froala-editor/js/languages/zh_cn')
// 引入 Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css')
require('font-awesome/css/font-awesome.css')
require('froala-editor/css/froala_style.min.css')

// 批量导入 froala-editor 插件文件
function importAll (r) {
  r.keys().forEach(r)
}
importAll(require.context('froala-editor/js/plugins/', false, /\.js$/))
importAll(require.context('froala-editor/css/plugins/', false, /\.css$/))

Vue.config.productionTip = false
Vue.prototype._ = _
Vue.use(less)
Vue.use(VueInteractJs)
Vue.use(VueResize)
Vue.use(ElementUI)
moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.prototype.$moment.recur = recur
axios.defaults.baseURL = process.env.API_ROOT
Vue.use(VueAxios, axios)
Vue.use(dataV)
Vue.use(VueFroala)
//使用格式化组件
Vue.use(format);
//定义事件总线 
Vue.prototype.$eventBus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

// axios 请求拦截器
axios.interceptors.request.use(config => {
  config.headers['role'] = localStorage.getItem('role');
  config.headers['user'] = localStorage.getItem('user');
  return config;
}, errorHandler)

// 异常拦截处理器
const errorHandler = (error) => {
  // 专门应对"Network Error"这种错误
  if (!!error.isAxiosError && !error.response) {
    error.message = '网络连接错误!'
  }

  // if (error && error.response) {
  //   const status = error.response.status;
  //   switch (status) {
  //     /* eslint-disable no-param-reassign */
  //     case 400: error.message = '请求错误'; break;
  //     case 401: error.message = '未授权，请登录'; break;
  //     case 403: error.message = '拒绝访问'; break;
  //     case 404: error.message = `请求地址出错: ${error.response.config.url}`; break;
  //     case 408: error.message = '请求超时'; break;
  //     case 500: error.message = '服务器内部错误'; break;
  //     case 501: error.message = '服务未实现'; break;
  //     case 502: error.message = '网关错误'; break;
  //     case 503: error.message = '服务不可用'; break;
  //     case 504: error.message = '网关超时'; break;
  //     case 505: error.message = 'HTTP版本不受支持'; break;
  //     default: break;
  //     /* eslint-disabled */
  //   }
  // }
  return Promise.reject(error);
};

// axios 响应拦截器
axios.interceptors.response.use(response => {
  if (response.status === 200) {
      return response
  } else {
      ElementUI.Message.error(response.data.msg ? response.data.msg : '系统异常！', {duration: 3 * 1000})
      return Promise.reject(response.data.msg)
  }
}, errorHandler)



// WEBPACK FOOTER //
// ./src/main.js